(() => {
  const initTripleMobileCarousel = (section) => {
    const track = section.querySelector('[data-mobile-products-track]');
    const prev = section.querySelector('[data-mobile-products-prev]');
    const next = section.querySelector('[data-mobile-products-next]');

    if (!track || !prev || !next) return;

    const slides = Array.from(track.children);
    const total = slides.length;

    let index = 0;

    const update = () => {
      const width = track.clientWidth;
      track.scrollTo({
        left: index * width,
        behavior: 'smooth'
      });
    };

    const goNext = () => {
      index++;

      if (index >= total) {
        index = 0; // loop al inicio
      }

      update();
    };

    const goPrev = () => {
      index--;

      if (index < 0) {
        index = total - 1;
      }

      update();
    };

    next.addEventListener('click', goNext);
    prev.addEventListener('click', goPrev);
  };

  const initAll = () => {
    document
      .querySelectorAll('[data-triple-hover-products]')
      .forEach(initTripleMobileCarousel);
  };

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-triple-hover-products]');
    if (section) initTripleMobileCarousel(section);
  });
})();